module.exports = "<div class=\"flex-between wrapper\">\n  <div *ngFor=\"let imagem of rodape?.imagens\" class=\"imagem\" [style.background-image]=\"'url(' + (imagem.arquivo.url) + ')'\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/rodape/rodape.component.html
// module id = ./src/app/components/rodape/rodape.component.html
// module chunks = main